var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-toolbar__container"},[(_vm.$vuetify.breakpoint.mdAndUp)?_c('the-toolbar-desktop',{attrs:{"id":"toolbar"}},[_vm._t("default")],2):_c('the-toolbar-mobile',{attrs:{"id":"toolbar"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }